import { createPinia } from 'pinia'
import piniaPersist from 'pinia-plugin-persist-uni'
import { piniaLogger } from '@/services/plugins/piniaLogger'

export const piniaStore = createPinia()
piniaStore.use(piniaPersist)
piniaStore.use(piniaLogger)

export function setupStore(app) {
    app.use(piniaStore)
}
